import { arrayIncludesAny } from '@nu-art/ts-common';
export function _canBeAddedToView(diseaseView, sourceTagGroup, otherTags) {
    //If source tag group was not provided
    if (!sourceTagGroup)
        return false;
    const whiteList = diseaseView.filter.tagIds?.whitelist;
    const blackList = diseaseView.filter.tagIds?.blacklist;
    //If we are not filtering by tags by this point instant true
    if (!whiteList?.length && !blackList?.length)
        return true;
    //If any tag id is in the black list the answer is no
    if (sourceTagGroup.value.some(id => blackList?.includes(id)))
        return false;
    //Either whitelist doesn't exist or the variable passes at least one whitelist id
    return !whiteList?.length || arrayIncludesAny(whiteList, sourceTagGroup.value);
}
//# sourceMappingURL=functions.js.map